import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Custom validator to check if two fields match (e.g., password and confirm password).
 * @param control The form group to validate.
 * @returns A ValidationErrors object if mismatch, otherwise null.
 */
export function passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
  const password = control.get('password');
  const confirmPassword = control.get('confirmPassword');

  // Return null if controls haven't been initialized yet or if one is missing
  if (!password || !confirmPassword) {
    return null;
  }

  // Set error on confirmPassword if validation fails, to display error message specifically on that field
  if (confirmPassword.errors && !confirmPassword.errors['passwordMismatch']) {
    // Preserve other errors on confirmPassword if any
    return null;
  }

  if (password.value !== confirmPassword.value) {
    confirmPassword.setErrors({ passwordMismatch: true });
    return { passwordMismatch: true }; // Return error for the form group as well
  } else {
    // Clear the error if passwords match and the error was previously set
    if (confirmPassword.hasError('passwordMismatch')) {
      confirmPassword.setErrors(null);
    }
    return null;
  }
}
